
$views.main = {
	
	refineSearchHighlight : true,
	safeEmails : [],
	
	resizeLHScolumn : function($help) {
		
		if ($views.all.getCurrentScreen() != 'main') return false;
		
		var $overallWindowHeight = jQuery(window).height();
		
		if (!jQuery('#help').is(":hidden")){
			$overallWindowHeight = jQuery(window).height() - (jQuery('#help').height());
		}
		
		var $searchFilterListHeight = ((jQuery('.soupmail-filter-bar').css('display') != "none") ? 0 : 50 );
		var $searchOptionsHeight =  ((jQuery('#search-options').css('display') != "none") ? (jQuery('#search-options').height()+30) : 0 );
		var $updateBarHeight = ((jQuery('#version-update-bar').css('display') != "none") ? jQuery('#version-update-bar').height() : 0);
		var $httpResourcesWarningHeight = jQuery('.warning-http-resources').outerHeight();
		
		jQuery('.soupmail-main-left .email-list').height($overallWindowHeight - 212 + $searchFilterListHeight - $searchOptionsHeight - $updateBarHeight);
		jQuery('#soupmail-email-preview').height($overallWindowHeight - 180 + $searchFilterListHeight - $updateBarHeight - $httpResourcesWarningHeight);
		
		if (jQuery("#soupmail-email-preview").size() > 0) {
			jQuery("#soupmail-email-preview").css('min-height', (jQuery(".soupmail-main-previewpane").height() - jQuery(".soupmail-main-previewpane .headers").height() - 30) + 'px');
		}
		
	},
	
	renderCachedContactsToFilterMenu : function($params) {
		
		//jQuery('#item_search_emails_sender ul, #item_search_emails_recepient ul').html('');
		
		// ensure that the person filter from dashboard always works 100% of the time - if we just got here from a person filter, ENSURE that email exists in from/to/cc
		if (($params != undefined) && ($params.person != undefined) && ($params.person != '')) {
			$cached.contacts.add($params.person, 'from', true);
			$cached.contacts.add($params.person, 'to', true);
			$cached.contacts.add($params.person, 'cc', true);
		}
		
		// add all cached FROM addresses to the filter dropdown submenu
		jQuery.each($cached.contacts.getAll(['from']).sort($cached.contacts.sort_by_name_alphabetically), function($key, $contact) {
			
			var $id = 'emails_from_' + $soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($contact.email));
			if (!$soupmail.helpers.filter.$filters._items.hasOwnProperty($id)) {
				$soupmail.helpers.filter.$filters._items[$id] = {icon:'person', e1:'addprefix', e2:'', id:$id, label:$contact.name, labelextra:' &nbsp;<small>&lt;'+$contact.email.substring(0,30)+'&gt;</small>', name:'emails_from['+$contact.email+']', parent:'search_emails_sender', selected:false, type:'checkbox', val:$contact.email};
				$soupmail.helpers.filter.$filters._items[$id]['click'] = function(event) {
					event.stopPropagation();
					$soupmail.helpers.filter.$filters.add(jQuery(this).attr('id'), 'standalone_display_mainpage #1');
				};
			}
			jQuery('#item_search_emails_sender #item_'+$id).remove();
			jQuery('#item_search_emails_sender ul').append('<li id="item_'+$id+'"></li>');
			
		});
		
		// add all cached TO and CC addresses to the filter dropdown submenu
		jQuery.each($cached.contacts.getAll(['to', 'cc']).sort($cached.contacts.sort_by_name_alphabetically), function($key, $contact) {
			
			var $id = 'emails_to_' + $soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($contact.email));
			if (!$soupmail.helpers.filter.$filters._items.hasOwnProperty($id)) {
				$soupmail.helpers.filter.$filters._items[$id] = {icon:'person', e1:'addprefix', e2:'', id:$id, label:$contact.name, labelextra:' &nbsp;<small>&lt;'+$contact.email.substring(0,30)+'&gt;</small>', name:'emails_to['+$contact.email+']', parent:'search_emails_recepient', selected:false, type:'checkbox', val:$contact.email};
				$soupmail.helpers.filter.$filters._items[$id]['click'] = function(event) {
					event.stopPropagation();
					$soupmail.helpers.filter.$filters.add(jQuery(this).attr('id'), 'standalone_display_mainpage #2');
				};
			}
			jQuery('#item_search_emails_recepient #item_'+$id).remove();
			jQuery('#item_search_emails_recepient ul').append('<li id="item_'+$id+'"></li>');
			
		});
		
		// add all cached FROM and TO and CC addresses to the filter dropdown submenu
		jQuery.each($cached.contacts.getAll(['from', 'to', 'cc']).sort($cached.contacts.sort_by_name_alphabetically), function($key, $contact) {
			
			var $id = 'emails_involving_' + $soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($contact.email));
			if (!$soupmail.helpers.filter.$filters._items.hasOwnProperty($id)) {
				$soupmail.helpers.filter.$filters._items[$id] = {icon:'person', e1:'addprefix', e2:'', id:$id, label:$contact.name, labelextra:' &nbsp;<small>&lt;'+$contact.email.substring(0,30)+'&gt;</small>', name:'emails_to['+$contact.email+']', parent:'search_emails_involving', selected:false, type:'checkbox', val:$contact.email};
				$soupmail.helpers.filter.$filters._items[$id]['click'] = function(event) {
					event.stopPropagation();
					$soupmail.helpers.filter.$filters.add(jQuery(this).attr('id'), 'standalone_display_mainpage #2(B)');
				};
			}
			jQuery('#item_search_emails_involving #item_'+$id).remove();
			jQuery('#item_search_emails_involving ul').append('<li id="item_'+$id+'"></li>');
			
		});
		
		// apply appropriate filterby buttons in the bar
		if (($params != undefined) && ($params.person != undefined) && ($params.person != '')) {
			$soupmail.helpers.filter.$filters.add('emails_involving_'+$soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($params.person)), 'standalone_display_mainpage #6(Z)', 1, true, false);
		}
		
		// rebuild the filter dropdown
//			$soupmail.helpers.filter.$filters.renderMenu();
		
	},
	
	renderCachedFoldersToFilterMenu : function($params, $skipRebuildOfFirst3) {
		
		console.log('renderCachedFoldersToFilterMenu()');
		
		var $searchboxForFolders = '<li id="item_search_folder_name">'+jQuery('ul#filter_folder_list #item_search_folder_name').html()+'</li>';
		//jQuery('ul#filter_folder_list').html($searchboxForFolders);
		
		var $i = 1;
		$views.main.popularFolders = [];
		
		// add all cached folders to the filter dropdown submenu
		jQuery.each($cached.folders.getAll(), function($key, $folder) {
			
			var $id = 'search_folders_folder' + $soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($folder.id));
			if (!$soupmail.helpers.filter.$filters._items.hasOwnProperty($id)) {
				$soupmail.helpers.filter.$filters._items[$id] = {icon:'folder', e1:'', e2:'', id:$id, label:$folder.reference+' | '+$folder.name, name:'search_folders[folder'+$folder.id+']', parent:'search_emails_folder', selected:false, type:'checkbox', val:'1'};
				$soupmail.helpers.filter.$filters._items[$id]['click'] = function(event) {
					event.stopPropagation();
					$soupmail.helpers.filter.$filters.add(jQuery(this).attr('id'), 'standalone_display_mainpage #3');
				};
			}
			if (jQuery('ul#filter_folder_list #item_'+$id).size() <= 0) {
				jQuery('ul#filter_folder_list').append('<li id="item_'+$id+'"></li>');
			}
			
			if (($views.main.popularFolders.length < 3) && ($folder.favourited == true)) {
				$views.main.popularFolders.push($soupmail.helpers.filter.$filters._items[$id]);
			}
			$i++;
			
		});
		
		// add the first 3 cached folders to the filter dropdown
		if ($skipRebuildOfFirst3 !== true) {
			jQuery('.filter_featured_folder').remove();
			jQuery.each($views.main.popularFolders, function($key, $item) {
				
				jQuery('ul#filter_folder_list').parent().before('<li id="item_'+$item.id+'" class="filter_featured_folder"></li>');
				
			});
		}
		
		// apply appropriate filterby buttons in the bar
		if (($params != null) && ($params.folder_ids != undefined) && ($params.folder_ids > 0)) {
//			$soupmail.helpers.filter.$filters.add('search_folders_folder'+$soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($params.folder_ids)), 'standalone_display_mainpage #4', 1, true, false);
		}
		
		// rebuild the filter dropdown... and if there are no cached folders to display, then don't bother showing the submenu or the <hr />
		if ($i > 1) {
//				$soupmail.helpers.filter.$filters.renderMenu();
			jQuery('#item_search_emails_folder, #search_emails_folder_divider').show();
		} else {
			jQuery('#item_search_emails_folder, #search_emails_folder_divider').hide();
		}
		
	},
	
	renderCachedTagsToFilterMenu : function($params) {
		
		//jQuery('#item_search_categories_folder ul').html('');
		
		var $i = 1;
		$views.main.first3Items = [];
		
		// add all cached tags to the filter dropdown submenu
		jQuery.each($cached.tags.getAll(), function($key, $tag) {
			
			var $id = 'search_categories_' + $tag.id;
			if (!$soupmail.helpers.filter.$filters._items.hasOwnProperty($id)) {
				$soupmail.helpers.filter.$filters._items[$id] = {icon:'tag', e1:'', e2:'', id:$id, label:$tag.name, name:'search_categories['+$tag.id+']', parent:'search_categories_folder', selected:false, type:'checkbox', val:'1'};
				$soupmail.helpers.filter.$filters._items[$id]['click'] = function(event) {
					event.stopPropagation();
					$soupmail.helpers.filter.$filters.add(jQuery(this).attr('id'), 'standalone_display_mainpage #5');
				};
			}
			if (jQuery('#item_search_categories_folder #item_'+$id).size() <= 0) {
				jQuery('#item_search_categories_folder ul').append('<li id="item_'+$id+'"></li>');
			}
			
			if ($i <= 3) {
				$views.main.first3Items.push($soupmail.helpers.filter.$filters._items[$id]);
			}
			$i++;
			
		});
		
		// add the first 3 cached tags to the filter dropdown
		jQuery('.filter_featured_tag').remove();
		jQuery.each($views.main.first3Items, function($key, $item) {
			
			jQuery('#item_search_categories_folder').before('<li id="item_'+$item.id+'" class="filter_featured_tag"></li>');
			
		});
		
		// apply appropriate filterby buttons in the bar
		if (($params != undefined) && ($params.tagid != undefined) && ($params.tagid != '')) {
			$soupmail.helpers.filter.$filters.add('search_categories_'+$soupmail.string.dashesToUnderscores($soupmail.string.stringUrlSafe($params.tagid)), 'standalone_display_mainpage #6', 1, true, false);
		}
		
		// rebuild the filter dropdown... and if there are no cached tags to display, then don't bother showing the submenu or the <hr />
		if ($i > 1) {
//				$soupmail.helpers.filter.$filters.renderMenu();
			jQuery('#item_search_categories_folder, #search_categories_folder_divider').show();
		} else {
			jQuery('#item_search_categories_folder, #search_categories_folder_divider').hide();
		}
		
	},
	
	renderEmail : function($emailid, $data, $body) {
		
		$emailid = parseInt($emailid);
		jQuery('.warning-http-resources').remove();
		
		$body = $soupmail.string.makeEmailClassesScoped($body);
		$body = $soupmail.string.removeScriptTags($body);
		console.log(jQuery.inArray($emailid, $views.main.safeEmails));
		if (jQuery.inArray($emailid, $views.main.safeEmails) < 0) {
			$body = $soupmail.string.makeHTTPresourcesNotLoad($body);
			if ($soupmail.string.containsHTTPresources($body)) {
				jQuery('.soupmail-main-right').prepend('<div class="warning-http-resources">This email contains insecure resources. For your privacy, these resources have not been loaded. <a href="#" onclick="return false">Show Remote Content</a></div>');
				jQuery('.warning-http-resources a').click(function() {
					$views.main.safeEmails.push($emailid);
					$models.main.getEmailPreview($emailid);
				});
				$views.main.resizeLHScolumn(true);
			}
		}
		
		var $target = '#soupmail-email-preview';
		var $dateObj = new $soupmail.helpers.SoupMailDate($data.sent_date);
		if (!$data.subject) { $data.subject = '(no subject)'; }
		
		var $ajaxHtmlForDiv = '<div id="popup-message-container"></div>';
		$ajaxHtmlForDiv += '<div class="headers">';
		
		if ($data.from) {
			$ajaxHtmlForDiv += '	<div class="header from"><label>From:</label> <span class="highlightable">'+$soupmail.string.emailAddressHtmlEscape($data.from, true)+'</span></div>';
			$ajaxHtmlForDiv += '	<div class="toggle-details"><a href="#" onclick="jQuery(\'.header.to, .header.cc, .header.attach, .header.meta\').slideToggle(); jQuery(this).toggleClass(\'expanded\'); return false"><span class="hide-details">Hide Details</span><span class="show-details">Show Details</span></a></div>';
		}
		
		if ($data.to.length > 0) {
			$ajaxHtmlForDiv += '	<div class="header to"><label>To:</label> <span class="highlightable">'+$soupmail.string.emailAddressHtmlEscape($data.to, true)+'</span></div>';
		}
		
		if ($data.cc.length > 0) {
			$ajaxHtmlForDiv += '	<div class="header cc"><label>CC:</label> <span class="highlightable">'+$soupmail.string.emailAddressHtmlEscape($data.cc, true)+'</span></div>';
		}
		
		if (($data.attachments != null) && ($data.attachments.length > 0)) {
			$ajaxHtmlForDiv += '	<div class="header attach">';
			$ajaxHtmlForDiv += '		<label><span>Attachments:</span></label>';
			jQuery.each($data.attachments, function($key, $attachment) {
				var $comma = (($key < ($data.attachments.length - 1)) ? ', &nbsp;' : '');
				if ((typeof($attachment.content_type) == 'string') && $attachment.content_type) {
					var $content_type = $soupmail.string.stringHtmlAttributeSafe($attachment.content_type);
				} else {
					var $content_type = 'unknown_type';
				}
				if ($attachment.file_size > (1024 * 1024 * 1024)) {
					var $attachmentSize = parseFloat($attachment.file_size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
				} else if ($attachment.file_size > (1024 * 1024)) {
					var $attachmentSize = parseFloat($attachment.file_size / 1024 / 1024).toFixed(2) + ' MB';
				} else if ($attachment.file_size > (1024)) {
					var $attachmentSize = parseInt($attachment.file_size / 1024) + ' KB';
				} else {
					var $attachmentSize = parseInt($attachment.file_size) + ' bytes';
				}
				$ajaxHtmlForDiv += '	<div class="attach attach_'+$content_type+' highlightable"><a href="'+$config.api_protocol+$config.api_hostname+$config.api_path+'/attachments/'+$attachment.id+'?token='+$models.login.getToken()+'">'+$soupmail.string.basicHtmlEscape($attachment.filename)+' ('+$attachmentSize+')</a>'+$comma+'</div>';
			});
			$ajaxHtmlForDiv += '		<div class="clear"></div>';
			$ajaxHtmlForDiv += '	</div>';
		}
		
		$ajaxHtmlForDiv += '	<div class="header meta">';
		if ($data.folder && $data.folder.id) {
			$ajaxHtmlForDiv += '		<div class="folder highlightable"><a href="#" onclick="$controllers.main.display({folder_ids: \''+$data.folder.id+'\'})">'+$data.folder.reference+' | '+$soupmail.string.basicHtmlEscape($data.folder.name)+'</a></div>';
		}
		$ajaxHtmlForDiv += '			<div id="tags_editable"></div>';
		$ajaxHtmlForDiv += '	</div>';
		
		if ($data.subject) {
			$ajaxHtmlForDiv += '	<div class="options"><a class="download" href="'+$config.api_protocol+$config.api_hostname+$config.api_path+'/emails/'+$emailid+'.eml?token='+$models.login.getToken()+'">Download Email</a><a href="#" class="delete" onclick="$controllers.main.deleteEmail('+$emailid+'); return false">Delete email</a></div>';
			$ajaxHtmlForDiv += '	<h1 class="highlightable">'+$soupmail.string.basicHtmlEscape($data.subject)+'</h1>';
		}
		
		if ($data.sent_date) {
			$ajaxHtmlForDiv += '	<div class="header date highlightable">'+$dateObj.getEmailPreviewDate()+'</div>';
		}
		
		$ajaxHtmlForDiv += '</div>';
		
		$ajaxHtmlForDiv += '<div class="body highlightable">';
		$ajaxHtmlForDiv += 	$body;
		$ajaxHtmlForDiv += '</div>';
		
		$views.all.handleLoadedAjaxData($ajaxHtmlForDiv, $target, false);
		
		jQuery($target + ' .body a').attr('target', '_blank');
		jQuery($target + ' .body a[href^="#"]').click(function(e) {
			e.preventDefault();
		});
		
		jQuery('.soupmail-main-right').animate({ scrollTop: 0, scrollLeft: 0 }, 'fast');
		
		// determine whether we are the folder owner of this folder
// NOTE: in #1409 we have some notes about this.... currently we are loading folder details first, then showing tags, this is inefficient but the only solution at present
		$models.folders.getItem($data.folder.id, function($folderDetails) {
			
			// display the Tags editable box
			$views.main.currentPreviewEmailId = $emailid;
			$views.main.tagsEditable = new $soupmail.control.editable({
				selector : '#tags_editable',
				model : 'emails',
				listArrayKey : '',
				itemId : $emailid,
				column : { name:'tags', label:'', cssclass:'', layoutView:'', layoutEdit:'<div class="label">Tags (comma separated):</div><input id="email_tags" class="text" type="text" value="" maxlength="500" name="email_tags">', onAfterRender:function(email, obj) {
					var tagsHtml = '';
					for (var i in email.tags) {
						var $tag = email.tags[i];
						tagsHtml += '<div class="category highlightable"><a href="#" onclick="$controllers.main.display({tagid: \''+$tag+'\', \'filters[tags]\': \''+$tag+'\'})">'+$soupmail.string.basicHtmlEscape($tag)+'</a></div>';
					}
					obj.find('.value').html(tagsHtml);
				} },
				editingEnabled : $models.login.hasEmailTagEditingPrivileges($folderDetails.owner_email, ''),
				dataItemRowClass : 'teamname',
				validation : false
			});
			$views.main.tagsEditable.change(function() {
				jQuery('#tags_editable .savebutton input').click(function() {
					var updatedTags = $views.main.tagsEditable.val();
					$models.emails.setItem($views.main.currentPreviewEmailId, updatedTags, function($data) {
						$views.main.tagsEditable.val($data.email.tags);
					});
				});
			});
			$views.main.tagsEditable.load();
			
		});
		
	},
	
	removeEmailPreview : function() {
		
		jQuery('#soupmail-email-preview').html('');
		
	},
	
	applyRelatedEmailsHighlighting : function($related) {
		jQuery('.highlighted-email').removeClass('highlighted-email');
		jQuery.each($related, function($key, $message_id) {
			if ($message_id != null) {
				jQuery('#item-'+$soupmail.string.stringHtmlAttributeSafe($message_id)).addClass('highlighted-email');
			}
		});
	},
	
	applyKeywordsHighlighting : function() {
		jQuery('.highlighted-keyword').each(function() {
			jQuery(this).replaceWith(jQuery(this).html());
		});
		
		var $keywords = jQuery('#mod-search-searchword').val();
		if (!$keywords || ($keywords == 'Refine Search...')) { return false; }
		
		$keywords = $keywords.split(' ');
		jQuery('#soupmail-email-preview .highlightable, .email-list-item h3, .email-list-item .subject, .email-list-item .intro').each(function() {
			jQuery(this).highlight($keywords, {element: 'span', className: 'highlighted-keyword'});
		});
		jQuery('#searchbox-highlight').addClass('unhighlight');	
	},
	
	toggleKeywordsHighlighting : function() {
		
		if ($views.main.refineSearchHighlight == false){
			jQuery('.highlighted-keyword').each(function() {
				jQuery(this).replaceWith(jQuery(this).html());
			});
			
			var $keywords = jQuery('#mod-search-searchword').val();
			if (!$keywords) { return false; }
			
			$keywords = $keywords.split(' ');
			jQuery('#soupmail-email-preview .highlightable, .email-list-item h3, .email-list-item .subject, .email-list-item .intro').each(function() {
				jQuery(this).highlight($keywords, {element: 'span', className: 'highlighted-keyword'});
			});
			jQuery('#searchbox-highlight').addClass('unhighlight');
			$views.main.refineSearchHighlight = true;
		} else {
			jQuery('.highlighted-keyword').each(function() {
				jQuery(this).replaceWith(jQuery(this).html());
			});
			
			var $keywords = jQuery('#mod-search-searchword').val();
			if (!$keywords) { return false; }
			
			$keywords = $keywords.split(' ');
			jQuery('#soupmail-email-preview .highlightable, .email-list-item h3, .email-list-item .subject, .email-list-item .intro').each(function() {
				jQuery(this).unhighlight($keywords, {element: 'span', className: 'highlighted-keyword'});
			});
			jQuery('#searchbox-highlight').removeClass('unhighlight');
			$views.main.refineSearchHighlight = false;
		}
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/views/desktop.mainpage.js